import store from '@/store'
import router from '@/router'
import axios from 'axios'

const axiosInstance = axios.create({
  baseURL: '/.netlify/functions/',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

axiosInstance.interceptors.response.use(
  function(response) {
    return response
  },
  function(error) {
    if (
      error.response.status === 401 &&
      error.response.data.message === 'Session expired, please log in again.'
    ) {
      store.commit('setAuth', {
        userId: null,
        sessionId: null
      })
      router.replace('/').finally()
    }
    return Promise.reject(error)
  }
)

export default axiosInstance
